module.exports = {
      id: "messenger-usage",
      viewBox: "0 0 28 28",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#messenger",
      toString: function () {
        return this.url;
      }
    }